<div class="tw-h-full tw-w-full tw-overflow-hidden">
  <div class="tw-flex tw-flex-col tw-h-full">
    @if (loading) {
      <loading class="tw-fixed tw-z-10 tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"></loading>
    }

    @if (!loading) {
      <div #scrollContainer
           class="tw-flex-1 tw-overflow-x-hidden tw-relative"
           [class.tw-flex]="isChatRoute"
           [class.tw-flex-col]="isChatRoute"
           [class.tw-overflow-hidden]="isChatRoute"
           [class.tw-overflow-y-auto]="!isChatRoute">
        <!-- Header: chat route uses the consultation header; other routes use the instruction header.
             Both are sticky-top via their own markup; preparation route renders no header. -->
        @if (isChatRoute) {
          <consultation-chat-header [consultationSession]="chatConsultationSession"
                                    [regimenClass]="chatRegimenClass"
                                    [botReplyInProgress]="chatProgressService.botReplyInProgress()"
                                    (back)="back()"></consultation-chat-header>
        } @else if (showHeader) {
          <instruction-header [title]="headerTitle"
                              [showPill]="showInstructionPill"
                              [sticky]="!showTabs"
                              [consultationSession]="chatConsultationSession"
                              [translateChatMessages]="false"
                              (back)="back()"></instruction-header>
        }

        <!-- Tabs: only shown when 2+ eligible tabs -->
        <!-- Tabs: content projected into sequential slots based on visibility order -->
        @if (showTabs) {
          <toolbar-tabs class="tw-sticky tw-top-0 tw-z-10 tw-w-full"
                        (tabSelected)="tabChange($event)"
                        [data]="tabData"
                        [shouldFormatTabData]="true">
            <tab1 class="tw-uppercase">
              @switch (visibleTabLabels[0]) {
                @case ('FACE') { <span i18n="@@face">Face</span> }
                @case ('HAIR') { <span i18n="@@hair">Hair</span> }
                @case ('OTHERS') { <span i18n="@@others">Others</span> }
              }
            </tab1>
            @if (visibleTabLabels.length >= 2) {
              <tab2 class="tw-uppercase">
                @switch (visibleTabLabels[1]) {
                  @case ('FACE') { <span i18n="@@face">Face</span> }
                  @case ('HAIR') { <span i18n="@@hair">Hair</span> }
                  @case ('OTHERS') { <span i18n="@@others">Others</span> }
                }
              </tab2>
            }
            @if (visibleTabLabels.length >= 3) {
              <tab3 class="tw-uppercase">
                @switch (visibleTabLabels[2]) {
                  @case ('FACE') { <span i18n="@@face">Face</span> }
                  @case ('HAIR') { <span i18n="@@hair">Hair</span> }
                  @case ('OTHERS') { <span i18n="@@others">Others</span> }
                }
              </tab3>
            }
          </toolbar-tabs>
        }

        @if (isChatRoute) {
          <chat-progress-bar stickyTopClass="tw-top-14"></chat-progress-bar>
        }

        <!-- Content — child participates in the same scroll flow.
             Reset scroll to top on each child activation so a new child page never
             inherits the previous page's scroll offset (the scroll container is shared
             across all shell children and is not recreated on child navigation). -->
        <router-outlet (activate)="scrollContainer.scrollTop = 0"></router-outlet>
      </div>
    }
  </div>
</div>
